import { Link } from "wouter";
import { ChevronRight } from "lucide-react";
import {
  Item,
  ItemGroup,
  ItemContent,
  ItemDescription,
  ItemActions,
  Separator,
} from "@sfc/ui";
import { type trpcVanilla } from "@client/trpc";

type Team = Awaited<
  ReturnType<typeof trpcVanilla.listTeams.query>
>["teams"][number];

export function TeamListItems({
  teams,
  hrefForTeam,
}: {
  teams: Team[];
  hrefForTeam: (id: string) => string;
}) {
  return (
    <ItemGroup>
      {teams.map((team, index) => (
        <div role="listitem" key={team.id}>
          <Item render={<Link href={hrefForTeam(team.id)} />}>
            <ItemContent className="min-w-0">
              <span className="heading-sm [overflow-wrap:anywhere]">
                {team.name}
              </span>
              <ItemDescription>
                {team._count.members}{" "}
                {team._count.members === 1 ? "member" : "members"}
              </ItemDescription>
            </ItemContent>
            <ItemActions>
              <ChevronRight
                className="size-4 text-muted-foreground"
                aria-hidden="true"
              />
            </ItemActions>
          </Item>
          {index < teams.length - 1 && <Separator />}
        </div>
      ))}
    </ItemGroup>
  );
}
